import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHousingStock = async (params) => {
  return await request.get(
    '/HousingStock',
    params,
    'При загрузке информации о жителях произошла ошибка'
  );
};

export const prefetchHousingStockQuery = async (queryClient, companyId) => {
  await queryClient.prefetchQuery(getQueryKeys.housingStock(companyId), () =>
    getHousingStock(companyId)
  );
};

const useHousingStock = (params, options = {}) => {
  const { companyId, houseId } = params;
  return useQuery(
    getQueryKeys.housingStock(companyId, houseId),
    () => getHousingStock(params),
    options
  );
};

export default useHousingStock;
